import { render, staticRenderFns } from "./mdi-icons.vue?vue&type=template&id=e8feceb0&"
import script from "./mdi-icons.vue?vue&type=script&lang=js&"
export * from "./mdi-icons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports